import MLoader from './MLoader.vue';

MLoader.install = (app) => {
  app.component('MLoader', MLoader);
};

export { MLoader };
